import { render } from "./form-filters.vue?vue&type=template&id=47f44fcc"
import script from "./form-filters.vue?vue&type=script&lang=js"
export * from "./form-filters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__